import { normalizeEurTryRate } from './creditCurrency';

export function creditTopUpAmountTry(value, currency, eurTryRate) {
  if (value === '' || value == null) return null;
  const amount = Number(value);
  const cents = Math.round(amount * 100);
  if (!Number.isFinite(amount) || amount <= 0 || !Number.isSafeInteger(cents)
    || Math.abs(amount * 100 - cents) > 0.000001) return null;
  if (currency === 'TRY') return cents / 100;
  const rate = normalizeEurTryRate(eurTryRate);
  if (currency !== 'EUR' || rate === null) return null;
  // Match whole-TRY package quotes without losing fractional EUR input.
  const scaledTry = cents * Math.round(rate * 10000) + 500000;
  return Number.isSafeInteger(scaledTry) ? Math.floor(scaledTry / 1000000) : null;
}
